import React from "react";
import { withRouter } from "../../utils/withRouter";
import { v4 as uuid } from "uuid";

import Loading from "../../components/Loading";
import {
  Collapse,
  LinearProgress,
  Tooltip,
  TextField,
  Button,
  Card,
  CardContent
} from "@material-ui/core";
import ThemeButton from "../../components/ThemeButton";
import EmailInstruction from "../../components/Reusable/EmailInstruction";
import Colors from "../../constants/colors";
import { connect } from "react-redux";
import ChipInput from "material-ui-chip-input";
import canvasTxt from "canvas-txt";
import { CompactPicker } from "react-color";
import { toast, Flip } from "react-toastify";
import AssetPicker from "../../components/AssetPicker";
import MusicAssetPicker from "../../components/MusicAssetPicker";
import {
  sendVideoToEmail,
  saveVideo,
  toggleSendVariable,
  sendMultipleEmails
} from "../../Redux/Actions/videos";
import * as Constants from "../../constants/constants";
import { reg } from "../../constants/emailRegEx";
import { EmailVideo, VideoSave, MultiEmail } from "../../Redux/Types/videos";
import { addAsset, addMusicAsset } from "../../Redux/Actions/asset";
import { getIconPosition } from "../../lib/helpers";
import "./style.css";
import {Auth, Storage} from "aws-amplify";
import { localStoragePut, localStorageGet } from "../../util/localStorage";

const isLocalAuth = process.env.REACT_APP_LOCAL_AUTH === 'true';

interface IProps {
  history: any;
  auth: any;
  videoToEdit: any;
  videoUser: any;
  addAsset: (asset: any) => void;
  addMusicAsset: (asset: any) => void;
  toggleSendVariable: () => void;
  sendVideoToEmail: (video: EmailVideo) => void;
  saveVideo: (video: VideoSave) => void;
  sendMultipleEmail: (emailVideoObj: any) => void;
  savedVideoId: string;
  progressEmail: boolean;
}

interface IState {
  logoPath: any;
  logoUrl: any;
  logoX: number | string;
  logoY: number | string;
  text: string;
  btnText: string;
  textColor: string;
  fontSize: number;
  vAlign: string;
  align: string;
  iconPos: string;
  imagePath: any;
  isAssetPicker: boolean;
  thumbnailBlob: any;
  videoProgress: boolean;
  progressVideo: number;
  thumbnailUrl: string;
  thumbnailPreviewUrl: string;
  videoUrl: string;
  title: string;
  emails: any;
  recieverEmail: string;
  musicTitle: string;
  backgroundMusicUrl: string;
  backgroundMusicKey: string;
  backgroundMusicType: string;
  musicFileSelected: boolean;
  musicFile: any;
  assetUploading: boolean;
  isOpenMusicPicker: boolean;
  musicLoadingTimeout: any;
  musicVolume: string;
  isThumbnailOpen: boolean;
  isLogoOpen: boolean;
  isTextOpen: boolean;
  isMusicOpen: boolean;
  isTitleOpen: boolean;
}
class AddLogoText extends React.Component<IProps, IState> {
  video: any;
  upload: any;
  img: any;
  musicRef: any;
  backgroundMusic: any;
  canvas: any;
  canvas2: any;
  cwidth: any;
  cheight: any;
  s3: any;
  ctx: any;
  ctx2: any;
  constructor(props: any) {
    super(props);
    this.state = {
      logoPath: null,
      logoUrl: null,
      isAssetPicker: false,
      isOpenMusicPicker: false,
      logoX: 10,
      logoY: 10,
      text: "",
      btnText: "Skip",
      textColor: "#fff",
      fontSize: 5,
      vAlign: "top",
      align: "left",
      iconPos: "top-left",
      imagePath: "",
      thumbnailBlob: "",
      videoProgress: false,
      progressVideo: 0,
      thumbnailUrl: "",
      thumbnailPreviewUrl: "",
      videoUrl: "",
      title: "",
      emails: [],
      recieverEmail: "",
      musicTitle: "",
      backgroundMusicUrl: "",
      backgroundMusicKey: "",
      backgroundMusicType: "",
      musicFileSelected: false,
      musicFile: null,
      assetUploading: false,
      musicLoadingTimeout: null,
      musicVolume: "0.5",
      isThumbnailOpen: false,
      isLogoOpen: false,
      isTextOpen: false,
      isMusicOpen: false,
      isTitleOpen: true
    };
  }
  componentDidMount() {
    this.props.toggleSendVariable();
    this.backgroundMusic = this.refs.backgroundMusic;
    this.video = this.refs.video;
    this.video.src = URL.createObjectURL(this.props.videoToEdit);
    this.canvas = this.refs.canvas;
    this.canvas2 = this.refs.dummyCanvas;
    this.img = this.refs.image;
    this.img.crossOrigin = "Anonymous";
    this.ctx = this.canvas.getContext("2d");
    this.ctx2 = this.canvas2.getContext("2d");
    this.video.addEventListener("loadedmetadata", this.handleLoadedMetaData);
    this.video.addEventListener("loadeddata", this.handleLoadedData);
    this.video.addEventListener("play", this.onVideoPlay, false);
    this.video.addEventListener("pause", this.onVideoPause);
    this.video.addEventListener("ended", this.onVideoEnd);
    this.video.addEventListener("volumechange", this.syncAudio);
  }
  onVideoPlay = () => {
    if (
      this.state.backgroundMusicUrl &&
      this.backgroundMusic.readyState !== 4
    ) {
      toast.info("Adding background music to video , Please wait");
      return;
    } else {
      this.backgroundMusic.play();
    }
    this.draw(
      this.video,
      this.img,
      this.ctx,
      this.video.clientWidth,
      this.video.clientHeight
    );
  };
  handleLoadedMetaData = () => {
    const width = this.video.clientWidth || this.video.videoWidth;
    const height = this.video.clientHeight || this.video.videoHeight;
    if (!width || !height) {
      return;
    }
    this.canvas.width = width;
    this.canvas.height = height;
  };
  handleLoadedData = () => {
    this.handleLoadedMetaData();
    this.updateCanvas();
  };
  toggleAssetPicker = () => {
    this.setState({ isAssetPicker: !this.state.isAssetPicker });
  };
  setInputRef = (ref: any) => {
    this.upload = ref;
  };
  triggerFileUploadBtn = () => {
    this.upload.click();
  };
  setMusicInputRef = (ref: any) => {
    this.musicRef = ref;
  };
  toggleMusicAssetPicker = () => {
    this.setState({ isOpenMusicPicker: !this.state.isOpenMusicPicker });
  };
  triggerMusicUploadBtn = () => {
    this.musicRef.click();
  };
  onFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files![0] !== null) {
      if (!e.target.files![0].name.match(/\.(jpg|jpeg|png)$/)) {
        toast.error("Please add valid image");
        return;
      }
      toast.info("Uploading logo please wait");
      await this.compress(e.target.files![0]);
    } else {
      toast.error("error in selecting file");
    }
  };

  draw = (
    video: any,
    img: any,
    context: any,
    width: any,
    height: any
  ) => {
    if (video.paused || video.ended) return false;
    context.clearRect(0, 0, width, height);
    canvasTxt.fontSize = (this.state.fontSize / 100) * (width - 80);
    context.fillStyle = this.state.textColor;
    canvasTxt.vAlign = this.state.vAlign;
    canvasTxt.align = this.state.align;
    canvasTxt.lineHeight = 20;
    canvasTxt.drawText(
      context,
      this.state.text,
      30,
      30,
      width - 50,
      height - 50
    );
    if (img && img.complete && img.naturalWidth > 0) {
      let logoDimension = 0.2 * width;
      context.drawImage(
        img,
        this.state.logoX,
        this.state.logoY,
        logoDimension,
        logoDimension
      );
    }
    let that = this;
    setTimeout(function() {
      that.draw(video, img, context, width, height);
    }, 0);
  };
  updateDrawCanvas = (
    video: any,
    img: any,
    context: any,
    width: any,
    height: any
  ) => {
    context.clearRect(0, 0, width, height);
    context.fillStyle = this.state.textColor;
    canvasTxt.vAlign = this.state.vAlign;
    canvasTxt.align = this.state.align;
    canvasTxt.lineHeight = 20;
    canvasTxt.fontSize = (this.state.fontSize / 100) * (width - 80);
    canvasTxt.drawText(
      context,
      this.state.text,
      30,
      30,
      width - 50,
      height - 50
    );
    if (img && img.complete && img.naturalWidth > 0) {
      let logoDimension = 0.2 * width;
      context.drawImage(
        img,
        this.state.logoX,
        this.state.logoY,
        logoDimension,
        logoDimension
      );
    }
  };
  updateCanvas = () => {
    if (!this.video) {
      return;
    }
    const width = this.video.clientWidth || this.video.videoWidth;
    const height = this.video.clientHeight || this.video.videoHeight;
    if (!width || !height) {
      return;
    }
    this.updateDrawCanvas(
      this.video,
      this.img,
      this.ctx,
      width,
      height
    );
  };
  compress(file: any) {
    this.setState({ assetUploading: true });
    const width = 100;
    const height = 100;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event: any) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const elem = document.createElement("canvas");
        elem.width = width;
        elem.height = height;
        const ctx: any = elem.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        ctx.canvas.toBlob(
          async (blob: any) => {
            await this.saveLogo(blob);
            this.setState({ assetUploading: false });
            toast.info("Logo uploaded");
          },
          `${file.type}`,
          1
        );
      };
    };
  }
  saveLogo = (logoBlob: any) => {
    return new Promise<void>((resolve, reject) => {
      const uploadFn = isLocalAuth ? localStoragePut : Storage.put;
      const getFn = isLocalAuth ? localStorageGet : Storage.get;
      uploadFn(`${uuid()}-logo`, logoBlob, isLocalAuth ? {} : {
        level: "protected" as any,
      }).then((response: any) => {
        getFn(response.key, {level: "protected"}).then((_response: any) => {
          this.setState({ logoPath: response.key, logoUrl: _response }, () => {
            setTimeout(() => {
              this.updateCanvas();
            }, 1000);
          });
        })
        this.props.addAsset({ type: "logo", url: response.key });
        resolve();
      }).catch((error: any) => {
        toast.error(error);
        this.setState({ assetUploading: false });
        reject(error);
      });
      // api.uploadFile(
      //     `${uuid}-logo`,
      //     logoBlob,
      //     {}
      // ).then((response: { filename: any; }) => {
      //   this.setState({ logoPath: response.filename }, () => {
      //     setTimeout(() => {
      //       this.updateCanvas();
      //     }, 1000);
      //   });
      //   this.props.addAsset({ type: "logo", url: response.filename });
      //   resolve();
      // }).catch((error: any) => {
      //   toast.error(error);
      //   this.setState({ assetUploading: false });
      //   reject(error);
      // });
    });
  };
  setIconPosition = (position: string) => {
    if (this.state.logoPath === null) {
      toast.info("Please upload a logo");
      return;
    }
    this.setState({ iconPos: position });
    let x, y: any;
    switch (position) {
      case "top-left":
        this.setState({ logoX: 20, logoY: 20 }, () => this.updateCanvas());
        return;
      case "bottom-left":
        x = 20;
        y = this.canvas.height - this.img.height - this.img.height / 2;
        this.setState({ logoX: x, logoY: y }, () => this.updateCanvas());
        return;
      case "bottom-right":
        x = this.canvas.width - this.img.width - this.img.width / 2;
        y = this.canvas.height - this.img.height - this.img.height / 2;
        this.setState({ logoX: x, logoY: y }, () => this.updateCanvas());
        return;
      case "top-right":
        x = this.canvas.width - this.img.width - this.img.width / 2;
        this.setState({ logoX: x, logoY: 20 }, () => this.updateCanvas());
        return;
      default:
        return;
    }
  };
  setTextPosition = (position: string) => {
    switch (position) {
      case "top-left":
        this.setState({ align: "left", vAlign: "top" }, () =>
          this.updateCanvas()
        );
        return;
      case "bottom-left":
        this.setState({ align: "left", vAlign: "bottom" }, () =>
          this.updateCanvas()
        );
        return;
      case "bottom-right":
        this.setState({ align: "right", vAlign: "bottom" }, () =>
          this.updateCanvas()
        );
        return;
      case "top-right":
        this.setState({ align: "right", vAlign: "top" }, () =>
          this.updateCanvas()
        );
        return;
      case "center":
        this.setState({ align: "center", vAlign: "middle" }, () =>
          this.updateCanvas()
        );
        return;
      case "center-bottom":
        this.setState({ align: "center", vAlign: "bottom" }, () =>
          this.updateCanvas()
        );
        return;
      default:
        return;
    }
  };
  changeText = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ text: e.target.value }, () => this.updateCanvas());
  };
  handleChangeColor = (color: any) => {
    this.setState({ textColor: color.hex }, () => this.updateCanvas());
  };
  changeFontSize = (e: any) => {
    this.setState({ fontSize: Number(e.target.value) }, () =>
      this.updateCanvas()
    );
  };
  onAssetPick = (path: any) => {
    const getFn = isLocalAuth ? localStorageGet : Storage.get;
    getFn(path, {level: "protected"}).then((_response: any) => {
      this.setState({ logoPath: path, logoUrl: _response }, () => this.updateCanvas());
      toast.info("updated");
    })
  };
  getThumbnail = () => {
    return new Promise<Blob>((resolve, reject) => {
      const thumbCanvas: any = this.refs.thumbCanvas;
      if (!thumbCanvas) {
        reject(new Error("Thumbnail canvas not ready"));
        return;
      }
      const thumbnailContext = thumbCanvas.getContext("2d");
      if (!thumbnailContext) {
        reject(new Error("Thumbnail context not available"));
        return;
      }
      try {
        const iconPos = getIconPosition(this.state.iconPos);
        thumbnailContext.drawImage(this.video, 0, 0, 1280, 720);
        thumbnailContext.fillStyle = this.state.textColor;
        canvasTxt.fontSize = (this.state.fontSize / 100) * 1100;
        canvasTxt.vAlign = this.state.vAlign;
        canvasTxt.align = this.state.align;
        canvasTxt.lineHeight = 20;
        canvasTxt.drawText(
          thumbnailContext,
          this.state.text,
          60,
          60,
          1280 - 120,
          720 - 120
        );
        if (this.state.logoPath) {
          thumbnailContext.drawImage(this.img, iconPos.x, iconPos.y);
        }
      } catch (error) {
        reject(error);
        return;
      }
      try {
        thumbCanvas.toBlob((blob: any) => {
          if (!blob) {
            reject(new Error("Failed to create thumbnail blob"));
            return;
          }
          resolve(blob);
        }, "image/jpeg");
      } catch (error) {
        reject(error);
      }
    });
  };
  captureThumbnail = async () => {
    if (!this.video || this.video.readyState < 2) {
      toast.warn("Wait for the video to load before capturing");
      return;
    }
    if (this.state.thumbnailPreviewUrl) {
      URL.revokeObjectURL(this.state.thumbnailPreviewUrl);
    }
    try {
      const blob = await this.getThumbnail();
      const thumbnailPreviewUrl = URL.createObjectURL(blob);
      this.setState({ thumbnailBlob: blob, thumbnailPreviewUrl });
      toast.success("Thumbnail captured");
    } catch (error) {
      console.error("Error capturing thumbnail", error);
      toast.error(
        "Failed to capture thumbnail. If you selected a logo from assets, check CORS."
      );
    }
  };
  removeThumbnail = () => {
    if (this.state.thumbnailPreviewUrl) {
      URL.revokeObjectURL(this.state.thumbnailPreviewUrl);
    }
    this.setState({
      thumbnailBlob: "",
      thumbnailPreviewUrl: "",
      thumbnailUrl: ""
    });
  };
  toggleThumbnailCard = () => {
    this.setState(prevState => ({
      isThumbnailOpen: !prevState.isThumbnailOpen
    }));
  };
  toggleLogoCard = () => {
    this.setState(prevState => ({
      isLogoOpen: !prevState.isLogoOpen
    }));
  };
  toggleTextCard = () => {
    this.setState(prevState => ({
      isTextOpen: !prevState.isTextOpen
    }));
  };
  toggleMusicCard = () => {
    this.setState(prevState => ({
      isMusicOpen: !prevState.isMusicOpen
    }));
  };
  toggleTitleCard = () => {
    this.setState(prevState => ({
      isTitleOpen: !prevState.isTitleOpen
    }));
  };
  uploadThumbnail = (filename: string, blob: Blob) => {
    return new Promise<string>((resolve, reject) => {
      const uploadFn = isLocalAuth ? localStoragePut : Storage.put;
      uploadFn(filename, blob, isLocalAuth
        ? { contentType: "image/jpeg" }
        : { level: "protected" as any, contentType: "image/jpeg" }
      )
        .then((response: any) => {
          this.setState({ thumbnailUrl: response.key });
          resolve(response.key);
        })
        .catch((error: any) => {
          console.error("Error uploading thumbnail", error);
          reject(error);
        });
    });
  };
  uploadVideo = (filename: string) => {
    return new Promise<void>((resolve, reject) => {
      this.setState({ videoProgress: true, progressVideo: 0 });
      const uploadFn = isLocalAuth ? localStoragePut : Storage.put;
      const progressCb = (progressEvent: { loaded: number; total: number; }) => {
        let uploaded: number = (progressEvent.loaded * 100) / progressEvent.total;
        this.setState({ progressVideo: uploaded });
      };
      uploadFn(filename, this.props.videoToEdit, isLocalAuth
        ? { progressCallback: progressCb }
        : { level: "protected" as any, progressCallback: progressCb }
      ).then((response: any) => {
        this.setState({
          videoProgress: false,
          videoUrl: response.key
        });
        resolve();
      }).catch((error: any) => {
        console.error("Error uploading video", error);
        reject(error);
      });
      // api
      //   .uploadFile(filename, this.props.videoToEdit, {
      //     onUploadProgress: (progressEvent: {
      //       loaded: number;
      //       total: number;
      //     }) => {
      //       let uploaded: number =
      //         (progressEvent.loaded * 100) / progressEvent.total;
      //       this.setState({ progressVideo: uploaded });
      //     }
      //   })
      //   .then((response: { filename: any }) => {
      //     this.setState({
      //       videoProgress: false,
      //       videoUrl: response.filename
      //     });
      //     resolve();
      //   })
      //   .catch((error: any) => {
      //     console.error("Error uploading video", error);
      //     reject(error);
      //   });
    });
  };
  uploadAndSaveMusicAsset = () => {
    if (this.state.musicTitle === "") {
      toast.error("Please add a title for music asset");
    } else {
      toast.info("Uploading music please wait");
      this.setState({ assetUploading: true });
      const uploadFn = isLocalAuth ? localStoragePut : Storage.put;
      uploadFn(`${uuid()}-music`, this.state.musicFile, isLocalAuth ? {} : {
        level: "protected" as any,
      }).then((response: any) => {
        toast.info("Asset Uploaded");
        this.setState({
          backgroundMusicUrl: response.key,
          musicFile: null,
          musicFileSelected: false,
          assetUploading: false
        });
        this.props.addMusicAsset({
          url: response.key,
          title: this.state.musicTitle
        });
      }).catch((error: any) => {
        toast.error(error);
        this.setState({ assetUploading: false });
      });
      // api.uploadFile(
      //     `${uuid}-music`,
      //     this.state.musicFile,
      //     {}
      // ).then((response: { filename: any; }) => {
      //   toast.info("Asset Uploaded");
      //   this.setState({
      //     backgroundMusicUrl: response.filename,
      //     musicFile: null,
      //     musicFileSelected: false,
      //     assetUploading: false
      //   });
      //   this.props.addMusicAsset({
      //     url: response.filename,
      //     title: this.state.musicTitle
      //   });
      // }).catch((error: any) => {
      //   toast.error(error);
      //   this.setState({ assetUploading: false });
      // });
    }
  };
  onMusicInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const audioTypes = /(\.|\/)(mp3|ogg|wav)$/i;
    let musicFile = e.target.files![0];
    if (!audioTypes.test(musicFile.name)) {
      toast.error("Please upload a valid audio file");
      return;
    }
    if (musicFile !== null) {
      toast("Add a title and  click upload to save this asset", {
        autoClose: 3000,
        transition: Flip
      });
      this.setState({ musicFileSelected: true, musicFile: musicFile });
    } else {
      toast.error("Failed to select a file try again");
    }
  };
  onMusicAssetPick = (path: any, type: string) => {
    const getFn = isLocalAuth ? localStorageGet : Storage.get;
    // @ts-ignore
    getFn(path, {level: type}).then((response: string) => {
      this.setState({ backgroundMusicUrl: response, backgroundMusicKey: path, backgroundMusicType: type });
      toast.info("Wait while we add the music to the video");
      this.setState({
        musicLoadingTimeout: setInterval(() => this.isMusicLoaded(), 3000)
      });
    })
  };

  // uploadThumbnail = (filename: string) => {
  //   return new Promise<void>((resolve, reject) => {
  //     this.setState({ videoProgress: true, progressVideo: 0 });
  //     api
  //       .uploadFile(filename, this.state.thumbnailBlob, {
  //         onUploadProgress: (progressEvent: {
  //           loaded: number;
  //           total: number;
  //         }) => {
  //           let uploaded: number =
  //             (progressEvent.loaded * 100) / progressEvent.total;
  //           this.setState({ progressVideo: uploaded });
  //         }
  //       })
  //       .then((response: { filename: any }) => {
  //         this.setState({
  //           videoProgress: false,
  //           thumbnailUrl: response.filename
  //         });
  //         resolve();
  //       })
  //       .catch((error: any) => {
  //         console.error("Error uploading thumbnail", error);
  //         reject(error);
  //       });
  //   });
  // };

  saveVideo = async () => {
    if (this.state.title === "") {
      toast.warn("Enter a title to save video");
      return;
    }
    if (!this.state.thumbnailBlob) {
      toast.warn("Capture a thumbnail before saving");
      return;
    }
    try {
      toast.info("Uploading video ...");
      const filename = uuid();
      await this.uploadVideo(`${filename}.mp4`);
      const thumbnailKey = await this.uploadThumbnail(
        `${filename}-thumbnail.jpg`,
        this.state.thumbnailBlob
      );
      let identityId = 'local';
      if (!isLocalAuth) {
        const currentUser = await Auth.currentUserCredentials();
        identityId = currentUser.identityId;
      }
      const textProps = {
        text: this.state.text,
        textColor: this.state.textColor,
        fontSize: this.state.fontSize,
        vAlign: this.state.vAlign,
        align: this.state.align
      };
      const logoProps = {
        url: this.state.logoPath,
        position: this.state.iconPos
      };
      const musicProps = {
        url: this.state.backgroundMusicKey,
        type: this.state.backgroundMusicType,
        musicVolume: parseFloat(this.state.musicVolume)
      };
      const video = {
        title: this.state.title,
        url: this.state.videoUrl,
        userId: this.props.auth!.user!._id,
        thumbnail: thumbnailKey,
        musicProps: musicProps,
        textProps: textProps,
        logoProps: logoProps,
        isVideo: true,
        identityId,
      };
      this.props.saveVideo(video);
    } catch (error: any) {
      console.error('Error saving video', error);
      toast.error("Failed to save video, Please try again");
    }
  };
  submitEmail = () => {
    if (this.props.savedVideoId === "") {
      return toast.warn("Please save a video");
    } else if (this.state.recieverEmail === "") {
      return toast.warn("Add an Email");
    } else if (!reg.test(this.state.recieverEmail)) {
      return toast.warn("Invalid Email");
    } else {
      const recieverEmail = this.state.recieverEmail;
      const video = {
        videoId: this.props.savedVideoId,
        recieverEmail
      };
      this.props.sendVideoToEmail(video);
      this.setState({ recieverEmail: "" });
    }
  };
  sendMultipleEmail = () => {
    if (this.state.emails.length === 0) {
      toast.error("No email provided");
      return;
    } else if (!this.props.savedVideoId) {
      toast.error("No video saved try again");
      return;
    } else {
      const emails = this.state.emails.join();
      const emailVideoObj = {
        recieverEmail: emails,
        videoId: this.props.savedVideoId
      };
      this.props.sendMultipleEmail(emailVideoObj);
      this.setState({ emails: [] });
    }
  };
  titleNameHandler = (event: any) => {
    this.setState({
      title: event.target.value
    });
  };
  emailHandler = (event: any) => {
    this.setState({
      recieverEmail: event.target.value
    });
  };
  onChangeMusicTitle = (e: any) => {
    this.setState({ musicTitle: e.target.value });
  };
  isMusicLoaded = () => {
    if (this.backgroundMusic && this.backgroundMusic.readyState === 4) {
      clearInterval(this.state.musicLoadingTimeout);
      this.setState({ musicLoadingTimeout: null });
      toast.info("Music added");
    }
  };
  handleChipAdd = (email: any) => {
    if (!reg.test(email)) {
      toast.error("Not a valid email");
      return;
    }
    this.setState({ emails: [...this.state.emails, email] });
  };
  handleDeleteChip = (delEmail: any) => {
    this.setState({
      emails: this.state.emails.filter((email: string) => email !== delEmail)
    });
  };
  navigateToVideos = () => {
    this.props.history.push("/videos");
  };
  removeListeners = () => {
    this.video.removeEventListener(
      "loadedmetadata",
      this.handleLoadedMetaData
    );
    this.video.removeEventListener("loadeddata", this.handleLoadedData);
    this.video.removeEventListener("pause", this.onVideoPause);
    this.video.removeEventListener("play", this.onVideoPlay);
    this.video.removeEventListener("ended", this.onVideoEnd);
    this.video.removeEventListener("volumechange", this.syncAudio);
  };
  syncAudio = () => {
    let videoVolume = this.video.volume * 100;
    this.backgroundMusic.volume =
      (parseFloat(this.state.musicVolume) / 100) * videoVolume;
  };
  onAdjustMusicVolume = (e: any) => {
    this.backgroundMusic.volume = e.target.value;
    this.setState({ musicVolume: e.target.value });
  };
  onVideoPause = () => {
    this.backgroundMusic.pause();
  };
  onVideoEnd = () => {
    this.backgroundMusic.currentTime = 0;
  };
  componentWillUnmount() {
    this.removeListeners();
    if (this.state.thumbnailPreviewUrl) {
      URL.revokeObjectURL(this.state.thumbnailPreviewUrl);
    }
  }
  render() {
    let { videoSaved, loading } = this.props.videoUser;
    let { progressEmail } = this.props;
    let { musicFileSelected, backgroundMusicUrl } = this.state;
    return (
      <div className="addLogoLayout">
        <h2 className="addLogoHeading">Customize your video</h2>
        <div className="altVideoSettingsRow">
          <div className="altVideoCol">
            <div className="altVideoWrapper">
              <video ref="video" controls width="100%" />
              <canvas ref="canvas" className="altCanvasOverlay" />
            </div>
          </div>
          <div className="altSettingsCol">
            {videoSaved !== true && (
              <div className="videoTitleField">
                <h3 className="addLogoMessage">Title</h3>
                <TextField
                  name="name"
                  value={this.state.title}
                  onChange={this.titleNameHandler}
                  placeholder="Give your video an amazing title"
                  type="text"
                  size="small"
                  variant="outlined"
                  fullWidth
                  style={{ marginTop: "6px" }}
                />
              </div>
            )}
            <div className="addLogoDiv">
              <div className="cardHeaderRow">
                <h3 className="addLogoMessage">
                  Add Logo
                  <Tooltip
                    title="upload a logo and play the video to see it"
                    placement="top"
                  >
                    <span style={iconStyle}>
                      <i className="fas fa-info"></i>
                    </span>
                  </Tooltip>
                </h3>
                <button
                  type="button"
                  className="cardToggleLink"
                  onClick={this.toggleLogoCard}
                >
                  {this.state.isLogoOpen ? "Collapse" : "Expand"}
                </button>
              </div>
              <Collapse in={this.state.isLogoOpen} timeout="auto" unmountOnExit>
                <div className="cardBody">
                  <AssetPicker
                    isOpen={this.state.isAssetPicker}
                    toggle={this.toggleAssetPicker}
                    onPick={this.onAssetPick}
                    logoAssets={true}
                  />
                  <input
                    id="uploadInput"
                    type="file"
                    onChange={this.onFileChange}
                    ref={this.setInputRef}
                    accept="image/x-png,image/gif,image/jpeg"
                  />
                  {this.state.assetUploading && <LinearProgress />}
                  <Button
                    onClick={this.triggerFileUploadBtn}
                    style={{
                      color: "#fff",
                      width: "135px",
                      backgroundColor: "#ff4301"
                    }}
                  >
                    Upload
                  </Button>

                  <Button
                    onClick={this.toggleAssetPicker}
                    style={{
                      color: "#fff",
                      marginLeft: "3px",
                      backgroundColor: "rgb(34, 185, 255)"
                    }}
                  >
                    Select from Assets
                  </Button>
                  <h5 className="positionTxt">Change Logo Position</h5>
                  <Button
                    style={logoPositionBtn}
                    onClick={() => this.setIconPosition("top-left")}
                  >
                    Top Left
                  </Button>
                  <Button
                    style={logoPositionBtn}
                    onClick={() => this.setIconPosition("top-right")}
                  >
                    Top Right
                  </Button>
                  <Button
                    style={logoPositionBtn}
                    onClick={() => this.setIconPosition("bottom-left")}
                  >
                    Bottom Left
                  </Button>
                  <Button
                    style={logoPositionBtn}
                    onClick={() => this.setIconPosition("bottom-right")}
                  >
                    Bottom Right
                  </Button>
                </div>
              </Collapse>
            </div>
            <div className="addMusicDiv">
              <div className="cardHeaderRow">
                <h3 className="addLogoMessage">
                  Add Music
                  <Tooltip title="upload audio music" placement="top">
                    <span style={iconStyle}>
                      <i className="fas fa-info"></i>
                    </span>
                  </Tooltip>
                </h3>
                <button
                  type="button"
                  className="cardToggleLink"
                  onClick={this.toggleMusicCard}
                >
                  {this.state.isMusicOpen ? "Collapse" : "Expand"}
                </button>
              </div>
              <Collapse in={this.state.isMusicOpen} timeout="auto" unmountOnExit>
                <div className="cardBody">
                  <MusicAssetPicker
                    isOpen={this.state.isOpenMusicPicker}
                    toggle={this.toggleMusicAssetPicker}
                    onPick={this.onMusicAssetPick}
                  />
                  <input
                    id="uploadInput"
                    type="file"
                    onChange={this.onMusicInputChange}
                    ref={this.setMusicInputRef}
                    accept="audio/*"
                  />
                  {musicFileSelected && (
                    <Button
                      onClick={this.uploadAndSaveMusicAsset}
                      style={{
                        color: "#fff",
                        width: "135px",
                        backgroundColor: "#ff4301"
                      }}
                    >
                      Upload
                    </Button>
                  )}
                  {!musicFileSelected && (
                    <Button
                      onClick={this.triggerMusicUploadBtn}
                      style={{
                        color: "#fff",
                        backgroundColor: "#ff4301"
                      }}
                    >
                      Select to Upload
                    </Button>
                  )}
                  <Button
                    onClick={this.toggleMusicAssetPicker}
                    style={{
                      color: "#fff",
                      marginLeft: "3px",
                      backgroundColor: "rgb(34, 185, 255)"
                    }}
                  >
                    Select from Assets
                  </Button>

                  {musicFileSelected && (
                    <TextField
                      type="text"
                      placeholder="Music Title"
                      value={this.state.musicTitle}
                      onChange={this.onChangeMusicTitle}
                      style={{ marginTop: "10px" }}
                    />
                  )}
                  {backgroundMusicUrl && (
                    <div className="musicVolumeAdjust">
                      <label>Adjust music volume</label>
                      <input
                        type="range"
                        value={this.state.musicVolume}
                        onChange={this.onAdjustMusicVolume}
                        min="0"
                        max="1"
                        step="0.1"
                      />{" "}
                    </div>
                  )}
                </div>
              </Collapse>
            </div>
            <div className="addTextDiv">
              <div className="cardHeaderRow">
                <h3 className="addLogoMessage">
                  Add Text
                  <Tooltip
                    title="enter text and play the video to see it"
                    placement="top"
                  >
                    <span style={iconStyle}>
                      <i className="fas fa-info"></i>
                    </span>
                  </Tooltip>
                </h3>
                <button
                  type="button"
                  className="cardToggleLink"
                  onClick={this.toggleTextCard}
                >
                  {this.state.isTextOpen ? "Collapse" : "Expand"}
                </button>
              </div>
              <Collapse in={this.state.isTextOpen} timeout="auto" unmountOnExit>
                <div className="cardBody">
                  <TextField
                    type="text"
                    placeholder="Add Text"
                    name="text"
                    value={this.state.text}
                    onChange={this.changeText}
                    style={{ width: "80%" }}
                  />
                  <h5 className="positionTxt">Change Text Position</h5>
                  <Button
                    style={logoPositionBtn}
                    onClick={() => this.setTextPosition("center")}
                  >
                    Center
                  </Button>
                  <Button
                    style={logoPositionBtn}
                    onClick={() => this.setTextPosition("center-bottom")}
                  >
                    Center Bottom
                  </Button>
                  <Button
                    style={logoPositionBtn}
                    onClick={() => this.setTextPosition("top-left")}
                  >
                    Top Left
                  </Button>
                  <Button
                    style={logoPositionBtn}
                    onClick={() => this.setTextPosition("top-right")}
                  >
                    Top Right
                  </Button>
                  <Button
                    style={logoPositionBtn}
                    onClick={() => this.setTextPosition("bottom-left")}
                  >
                    Bottom Left
                  </Button>
                  <Button
                    style={logoPositionBtn}
                    onClick={() => this.setTextPosition("bottom-right")}
                  >
                    Bottom Right
                  </Button>
                  <h5 className="positionTxt">Select Font Size</h5>
                  <div style={{ display: "flex", flexWrap: "nowrap" }}>
                    <input
                      type="range"
                      id="font"
                      name="font"
                      min="1"
                      max="10"
                      step="0.1"
                      style={{ width: "80%" }}
                      value={this.state.fontSize}
                      onChange={this.changeFontSize}
                    ></input>
                    <span style={{ width: "10%", padding: "10px" }}>
                      {Math.round((this.state.fontSize / 10) * 100)}px
                    </span>
                  </div>
                  <h5 className="positionTxt">
                    Choose Text Color
                    <span className="optionalText">(optional)</span>
                  </h5>
                  <CompactPicker
                    color={this.state.textColor}
                    onChangeComplete={this.handleChangeColor}
                  />
                </div>
              </Collapse>
            </div>
            <Card className="thumbnailCard">
              <CardContent className="thumbnailCardContent">
                <div className="cardHeaderRow">
                  <h3 className="addLogoMessage">Set Thumbnail</h3>
                  <button
                    type="button"
                    className="cardToggleLink"
                    onClick={this.toggleThumbnailCard}
                  >
                    {this.state.isThumbnailOpen ? "Collapse" : "Expand"}
                  </button>
                </div>
                <Collapse
                  in={this.state.isThumbnailOpen}
                  timeout="auto"
                  unmountOnExit
                >
                  <div className="cardBody">
                    <div className="thumbnailPicker">
                      <div className="thumbnailPickerContent">
                        <div className="thumbnailPickerControls">
                          <div className="thumbnailButtonRow">
                            <Button
                              style={{
                                color: "#fff",
                                backgroundColor: "#ff4301"
                              }}
                              onClick={this.captureThumbnail}
                            >
                              USE CURRENT FRAME
                            </Button>
                            <Button
                              style={{
                                color: "#fff",
                                backgroundColor: "rgb(34, 185, 255)"
                              }}
                              onClick={this.removeThumbnail}
                              disabled={!this.state.thumbnailPreviewUrl}
                            >
                              REMOVE THUMBNAIL
                            </Button>
                          </div>
                          <p className="thumbnailHint">
                            Pause or scrub the video to the frame you want before
                            capturing.
                          </p>
                        </div>
                      </div>
                      {this.state.thumbnailPreviewUrl && (
                        <div className="thumbnailPreviewWrap">
                          <img
                            className="thumbnailPreview"
                            src={this.state.thumbnailPreviewUrl}
                            alt="thumbnail preview"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </Collapse>
              </CardContent>
            </Card>
            <div style={{ display: "flex", justifyContent: "center" }}>
              {loading && <Loading />}
              {progressEmail && <Loading />}
            </div>
            {videoSaved !== true && (
              <div className="saveVideoSection">
                {this.state.videoProgress && (
                  <LinearProgress
                    variant="determinate"
                    value={this.state.progressVideo}
                  />
                )}
                <ThemeButton
                  style={{
                    backgroundColor: Colors.themeBlue,
                    color: Colors.white,
                    width: "100%"
                  }}
                  disabled={this.state.videoProgress || loading}
                  onClick={this.saveVideo}
                  name="Save Video"
                />
              </div>
            )}
            {videoSaved === true && (
              <div className="shareSection">
                <div className="saveShareEmailGroup">
                  <EmailInstruction heading="Reciever Email" />
                  <div className="saveShareEmailRow">
                    <TextField
                      placeholder="Enter email address"
                      type="text"
                      value={this.state.recieverEmail}
                      name="recieverEmail"
                      size="small"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true
                      }}
                      onChange={this.emailHandler}
                      style={{ flex: 1, minWidth: 0 }}
                    />
                    <ThemeButton
                      onClick={this.submitEmail}
                      name={`${Constants.SEND_THROUGH_EMAIL}`}
                      style={{
                        backgroundColor: Colors.themeGreen,
                        color: Colors.white,
                        whiteSpace: "nowrap"
                      }}
                    />
                  </div>
                </div>
                <div className="saveShareEmailGroup">
                  <EmailInstruction heading="Broadcast" />
                  <ChipInput
                    value={this.state.emails}
                    placeholder="Enter email and press enter"
                    fullWidth
                    onAdd={chips => this.handleChipAdd(chips)}
                    onDelete={chip => this.handleDeleteChip(chip)}
                  />
                  <ThemeButton
                    style={{
                      backgroundColor: Colors.themeGreen,
                      color: Colors.white,
                      marginTop: "8px"
                    }}
                    onClick={this.sendMultipleEmail}
                    name="Broadcast"
                  />
                </div>
                <ThemeButton
                  style={{
                    background: Colors.themeBlue,
                    color: Colors.white,
                    width: "100%",
                    marginTop: "8px"
                  }}
                  onClick={this.navigateToVideos}
                  name="Done"
                />
              </div>
            )}
          </div>
        </div>
        <canvas ref="dummyCanvas" style={{ display: "none" }} />
        <img
          crossOrigin="anonymous"
          alt="logo"
          src={this.state.logoUrl ? this.state.logoUrl : null}
          style={{ display: "none" }}
          ref="image"
        />
        <canvas
          ref="thumbCanvas"
          height={720}
          width={1280}
          style={{ display: "none" }}
        />
        <audio
          src={backgroundMusicUrl || undefined}
          ref="backgroundMusic"
          loop
          style={{ display: "none" }}
        />
      </div>
    );
  }
}
const iconStyle = {
  fontSize: "15px",
  color: "#a9a9a9",
  marginLeft: "7px",
  cursor: "pointer"
};
const logoPositionBtn = {
  marginBottom: "10px",
  marginLeft: "7px",
  fontSize: "11px",
  border: "1px solid #696969"
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    addAsset: (asset: any) => dispatch(addAsset(asset)),
    addMusicAsset: (asset: any) => dispatch(addMusicAsset(asset)),
    sendVideoToEmail: (video: EmailVideo) => dispatch(sendVideoToEmail(video)),
    saveVideo: (video: VideoSave) => dispatch(saveVideo(video)),
    toggleSendVariable: () => dispatch(toggleSendVariable()),
    sendMultipleEmail: (emailVideoObj: MultiEmail) =>
      dispatch(sendMultipleEmails(emailVideoObj))
  };
};
const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
    videoUser: state.video,
    savedVideoId: state.video.savedVideoId,
    progressEmail: state.video.progressEmail
  };
};
export default withRouter<any, any>(
  connect(mapStateToProps, mapDispatchToProps)(AddLogoText)
);
